import { FormGroup } from '@angular/forms';

export class QuestionBase<T> {
  value: T;
  id: string;
  key: string;
  placeholder: string;
  label: string;
  required: boolean;
  disabled: boolean;
  order: number;
  controlType: string;
  class: string;
  eventHandlers: any;
  childQuestions: any[];
  validators: any;
  form: FormGroup;
  isFormGroup = true;
  items: any[];
  hidden: boolean;

  constructor(
    options: {
      value?: T;
      id?: string;
      key?: string;
      label?: string;
      required?: boolean;
      disabled?: boolean;
      order?: number;
      controlType?: string;
      class?: string;
      placeholder?: string;
      eventHandlers?: any;
      childQuestions?: any[];
      validators?: any;
      items?: any[];
      hidden?: boolean;
    } = {}
  ) {
    this.value = options.value;
    this.key = options.key || '';
    this.placeholder = options.placeholder || '';
    this.id = options.id || this.key || '';
    this.label = options.label || '';
    this.required = !!options.required;
    this.disabled = !!options.disabled;
    this.order = options.order === undefined ? 1 : options.order;
    this.controlType = options.controlType || '';
    this.class = options.class || '';
    this.eventHandlers = options.eventHandlers || {};
    this.childQuestions = options.childQuestions || [];
    this.validators = options.validators || {};
    this.hidden = options.hidden || false;
  }

  parseValue(value): any {
    return value;
  }
}
